<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">汇好看直播电商</div>
            <div class="banner_line"></div>
            <div class="banner_title2">企业私域电商直播平台</div>
            <!-- <div class="banner_text">企业私域电商直播平台</div> -->
        </div>
        <img src="@/assets/Mobile/images/QcLiveBroadcast/banner.png" alt="">
      </div>
      <div class="programme programme1">
        <div class="content">
            <img src="@/assets/Mobile/images/QcLiveBroadcast/programme1.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">4大核心优势，解决业务痛点</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcLiveBroadcast/programme2.png" alt="">
        </div>
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">获客成本高，平台没人气，观众没互动？</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcLiveBroadcast/programme3.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">路人粉留不住，会员流失率高，没有留存和复购？</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcLiveBroadcast/programme4.png" alt="">
        </div>
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">使用第三方直播工具，数据不能打通溯源，分析深度广度有限？</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcLiveBroadcast/programme5.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">主播费用高、人效低，光有工具没人播？</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcLiveBroadcast/programme6.png" alt="">
        </div>
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">使用第三方直播工具，数据不能打通溯源，分析深度广度有限？</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcLiveBroadcast/programme7.png" alt="">
        </div>
      </div>
      <div class="programme" style="background:rgba(234,243,255,.67)">
        <div class="sk-mobile-title">
          <div class="title">客户案例</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcLiveBroadcast/case1.png" alt="">
            <img src="@/assets/Mobile/images/QcLiveBroadcast/case2.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="汇好看直播电商" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="汇好看直播电商" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcLiveBroadcast,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .programme1{
    background: #FFFFFF;
  }
  .programme2{
    background: #F8FBFF;
  }
  .programme3{
    background: #202239;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 22px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  